export default __webpack_public_path__ + "static/media/04.85798ecf.jpg";